<template>
<div>
  <el-table :data="importData.list">
    <el-table-column type="index" :label="$t('zhiji.knowlege.imExHistoryModal.order')" width="90" />
    <el-table-column property="file_name" :label="$t('zhiji.knowlege.imExHistoryModal.importFile')" width="250" />
    <el-table-column :label="$t('zhiji.knowlege.imExHistoryModal.importStatus')">
      <template slot-scope="scope">
        <div v-if="language === 'cn'">
          <span v-if="scope.row.task_status === 1 || scope.row.task_status === 0">导入进度：{{scope.row.schedule_percentage }}, 剩余时间：{{ formatTime(scope.row.surplus_time) }}</span>
        <span v-else-if="scope.row.task_status === 2">导入完成，导入成功标准问法{{ scope.row.import_standard_question_succ }}条，扩展问法{{ scope.row.import_ext_question_succ }}条，答案{{ scope.row.import_answer_succ }}条。
          导入失败标准问法{{ scope.row.import_standard_question_failed }}条，扩展问法{{ scope.row.import_ext_question_failed }}条，答案{{ scope.row.import_answer_failed }}条。</span>
        <span v-else-if="scope.row.task_error_info">{{scope.row.task_error_info}}，如有疑问联系v_syunzhang。</span>
        </div>
        <div v-else>
        <span v-if="scope.row.task_status === 1 || scope.row.task_status === 0">Import progress: {{scope.row.schedule_sercentage }}, Time Remaining: {{ formatTime(scope.row.surplus_time) }}</span>
        <span v-else-if="scope.row.task_status === 2">Import completed,import succeeded with {{ scope.row.import_standard_question_succ }} standard questions,{{ scope.row.import_ext_question_succ }} extended questions，and {{ scope.row.import_answer_succ }} answers.
          Import failed with {{ scope.row.import_standard_question_failed }} standard questions,{{ scope.row.import_ext_question_failed }} extended questions,and {{ scope.row.import_answer_failed }} answers.</span>
        <span v-else>Import failed, program error. Please contact administrator(v_syunzhang) for details.</span>
        </div>
      </template>
    </el-table-column>
    <el-table-column :label="$t('zhiji.knowlege.imExHistoryModal.importEndTime')" width="180">
      <template slot-scope="scope">
        <span v-if="scope.row.task_status === 1 || scope.row.task_status === 0">{{ scope.row.end_time + $t('zhiji.knowlege.imExHistoryModal.estimatedTime')}}</span>
        <span v-else>{{ scope.row.update_time }}</span>
      </template>
    </el-table-column>
    <el-table-column property="operator" :label="$t('zhiji.knowlege.imExHistoryModal.operator')" width="100" />
    <el-table-column :label="$t('zhiji.knowlege.imExHistoryModal.operation')" width="120">
      <template slot-scope="scope">
        <el-link v-if="scope.row.task_status === 2 && scope.row.import_failed_total > 0" type="danger" @click="downErrorData(scope.row.task_id)">{{$t('zhiji.knowlege.imExHistoryModal.downloadFailedFile')}}</el-link>
      </template>
    </el-table-column>
  </el-table>
  <FooterPage
    :size="importData.size"
    :total="importData.total"
    :page="importData.page"
    @sizeChange="sizeChange"
    @pageChange="pageChange"
  />
</div>
</template>

<script>
import FooterPage from '@/views/zhiji/components/foot-page.vue'
import { URLs } from "@/views/zhiji/js/common/constants.js";

export default {
  name: 'ImportStatus',
 components: {
    FooterPage
  },
  props: {
    status: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      importData: {
        list: [],
        page: 1,
        size: 10,
        total: 1,
      },
      language: '',
    };
  },
  watch: {
    status (modelStatus) {
      // eslint-disable-next-line no-unused-expressions
      modelStatus && this.getImportData();
    },
    "$i18n.locale": {
        handler(value) {
            this.language = value;
        },
        immediate: true
    },
  },
  mounted () {
    this.getImportData();
  },
  methods: {
    // 获取导入任务列表
    async getImportData () {
     const { list,count } = await this.zhiji.requestByServiceName("getFaqImportList",{
        page: this.importData.page,
        size: this.importData.size,
      })
      this.importData.list = list;
      this.importData.total = count;
    },
    sizeChange (newSize) {
      this.importData.size = newSize;
      this.importData.page = 1;
      this.getImportData();
    },
    pageChange (newPage) {
      this.importData.page = newPage;
      this.getImportData();
    },
    formatTime (time) {
      const h = Math.floor(time / 3600);
      const m = Math.floor((time / 60 % 60));
      const s = Math.floor((time % 60));
      return `${h}h${m}m${s}s`;
    },
    // 下载导入错误信息表
     downErrorData (task_id) {
      let reqUrl =
        URLs.BATCH_IMPORT_EERORINFO +
          `?task_id=${task_id}`;

      reqUrl = reqUrl.replace(/\s+/g, "");

      this.zhiji.requestByServiceName("downloadImportError", reqUrl).then(result => {
            window.open(result, "_blank");
        });
     },
  },
};
</script>
